import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import Chip from 'Chip';

import CorpNewsYears from './corpNewsYears';
import CorpNewsList from './corpNewsList';
import ConNav from './conNav';
import Banner from './banner';
class Content extends React.Component {
    constructor() {
        super();
        this.conNavHeader = {
            navCenter: '公司简介',
            navRight: '凤凰新媒体',
        };

        this.state = {
            yearsContent: '285147',
        };
    }

    static propTypes = {
        content: PropTypes.object,
    };

    handleMouseYears = index => {
        if (index === 0) {
            this.setState({
                yearsContent: '285147',
            });
        } else if (index === 1) {
            this.setState({
                yearsContent: '285132',
            });
        } else if (index === 2) {
            this.setState({
                yearsContent: '255939',
            });
        } else if (index === 3) {
            this.setState({
                yearsContent: '255940',
            });
        } else if (index === 4) {
            this.setState({
                yearsContent: '255941',
            });
        } else if (index === 5) {
            this.setState({
                yearsContent: '255942',
            });
        } else if (index === 6) {
            this.setState({
                yearsContent: '255943',
            });
        } else if (index === 7) {
            this.setState({
                yearsContent: '225822',
            });
        } else if (index === 8) {
            this.setState({
                yearsContent: '225823',
            });
        } else if (index === 9) {
            this.setState({
                yearsContent: '255944',
            });
        } else if (index === 10) {
            this.setState({
                yearsContent: '255945',
            });
        } else if (index === 11) {
            this.setState({
                yearsContent: '255946',
            });
        } else if (index === 12) {
            this.setState({
                yearsContent: '195915',
            });
        } else if (index === 13) {
            this.setState({
                yearsContent: '225824',
            });
        } else if (index === 14) {
            this.setState({
                yearsContent: '255947',
            });
        } else if (index === 15) {
            this.setState({
                yearsContent: '195916',
            });
        } else if (index === 16) {
            this.setState({
                yearsContent: '255948',
            });
        }
    };

    render() {
        const { content } = this.props;

        return (
            <div className={styles.pageBody}>
                <div className={styles.page}>
                    <div className={styles.pageHead}>
                        <div className={styles.pageEnd}>
                            <div className={styles.myContent}>
                                <Chip
                                    id="162635"
                                    type="static"
                                    title="首图banner"
                                    groupName="首图banner"
                                    content={content}>
                                    <Banner />
                                </Chip>
                                <ConNav conNavHeader={this.conNavHeader} />
                                <div className={styles.contIntro} id="record">
                                    <div className={styles.title}>
                                        <img src="http://img.ifeng.com/info/ifeng_record.gif" />
                                    </div>
                                    <Chip
                                        id="170186"
                                        type="struct"
                                        title="大事记年份"
                                        groupName="大事记年份"
                                        content={content}>
                                        <CorpNewsYears onMouseMove={index => this.handleMouseYears(index)} />
                                    </Chip>
                                </div>
                                <div className={styles.conChannel}>
                                    <Chip
                                        id={this.state.yearsContent}
                                        type="recommend"
                                        title="大事记年份内容"
                                        groupName="大事记年份内容"
                                        content={content}>
                                        <CorpNewsList yearsConData={this.state.yearsContent} />
                                    </Chip>
                                </div>
                            </div>
                            <div className={styles.clear} />
                        </div>
                    </div>
                </div>
                <div className={styles.border} />
            </div>
        );
    }
}

export default Content;
